import { useState, useEffect } from 'react';
import { formatPrice, getProductPrice } from '~/utilities/products';

import { useLocationPickerContext } from '~/context/LocationPickerContext';

const useProductPrice = (product, location = null) => {
    const { selectedLocation, locations } = useLocationPickerContext();
    const [price, setPrice] = useState('$-.--');

    useEffect(() => {
        if (!selectedLocation && !location && !locations.length) {
            setPrice('$-.--');
        } else if (!product?.productTypes.nodes.length) {
            setPrice(formatPrice(product.productInformation.price * 100));
        } else {
            const productPriceGroup = location
                ? location.priceGroup
                : selectedLocation
                  ? selectedLocation.priceGroup
                  : locations[0].priceGroup;
            let newPrice = getProductPrice(
                product,
                product?.productTypes.nodes[0].slug,
                productPriceGroup
            );
            setPrice(newPrice);
        }
    }, [selectedLocation, locations, product, location]);

    return price;
};

export default useProductPrice;
